export default __webpack_public_path__ + "static/media/Twitter.3822e9a2.svg";